export function defaultY(d) {
  return d[1];
}

export default function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/y.js
// module id = 1644
// module chunks = 3